import { Injectable } from '@angular/core';
import { WindowRefService } from './windowRef.service';

enum FlagTypes {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}

export enum FlagCloseProp {
  Auto = 'auto',
  Manual = 'manual',
  Never = 'never',
}

interface FlagProps {
  type: FlagTypes;
  body: string;
  title?: string;
  close: FlagCloseProp;
}

interface FlagOptions {
  close?: FlagCloseProp;
}

@Injectable()
export class FlagService {
  constructor(private windowRefService: WindowRefService) {}

  successMsg(body: string): void {
    this.flag({
      body,
      title: 'Success',
      type: FlagTypes.Success,
      close: FlagCloseProp.Auto,
    });
  }

  errorMsg(body: string, options: FlagOptions = {}): void {
    const { close = FlagCloseProp.Auto } = options;

    this.flag({
      body,
      title: 'Error',
      type: FlagTypes.Error,
      close,
    });
  }

  warningMsg(body: string): void {
    this.flag({
      body,
      title: 'Warning',
      type: FlagTypes.Warning,
      close: FlagCloseProp.Auto,
    });
  }

  private flag(props: FlagProps): void {
    this.windowRefService.AJS.flag(props);
  }
}
